export const navbar = {
  Search: 'Buscar',
  SearchPlaceholder: 'O que você quer ouvir?',
  Home: 'Início',
  'Your Library': 'Sua Biblioteca',
  'Collapse your library': 'Recolher sua biblioteca',
  'Expand your library': 'Expandir sua biblioteca',
  Language: 'Idioma',
  'Contact me': 'Fale comigo',
  COMPACT: 'Compacto',
  GRID: 'Grade',
  LIST: 'Lista',
};
